const _excluded = ["itemKey", "nested", "category", "defaultValue", "value", "onChange", "onClose", "onClick", "renderItem", "safePolygonArgs", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { noop, optionalPropType } from '@adsk/alloy-react-helpers';
import MenuItem from './MenuItem';
import useOverlayMenuItem from './useOverlayMenuItem';
import { menuCategoryShape } from '../helpers/propTypes';
import Menu from '../Menu';
/** An OverlayMenuItem component which handles nested items */
const OverlayMenuItem = _ref => {
  let {
      itemKey,
      nested,
      category,
      defaultValue,
      value = [],
      onChange = noop,
      onClose,
      onClick,
      renderItem = p => /*#__PURE__*/React.createElement(MenuItem, p),
      safePolygonArgs,
      style
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    isOpen,
    getOverlayMenuItemProps,
    getNestedMenuProps
  } = useOverlayMenuItem({
    placement: 'right-start',
    disabled: rest.disabled,
    nested,
    itemKey,
    category,
    onClick,
    onChange,
    onClose,
    value,
    safePolygonArgs
  });
  return renderItem(_objectSpread(_objectSpread({
    style
  }, getOverlayMenuItemProps(rest)), {}, {
    'data-testid': "menu-item--".concat(itemKey),
    nested: !!nested,
    showSelection: category === null || category === void 0 ? void 0 : category.showSelection,
    children: nested && isOpen ? /*#__PURE__*/React.createElement(Menu, _extends({}, getNestedMenuProps(), {
      options: nested,
      defaultValue: defaultValue,
      value: value,
      onChange: onChange,
      onClose: onClose
    })) : undefined
  }));
};
OverlayMenuItem.displayName = 'MenuItemWrapper';
OverlayMenuItem.propTypes = _objectSpread(_objectSpread({}, MenuItem.propTypes), {}, {
  /** Item key for the option has to be unique among all catagories */
  itemKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /** The category of this item */
  category: menuCategoryShape,
  /** nested menu items */
  nested: PropTypes.array,
  /** Pre selected keys */
  defaultValue: optionalPropType(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired)),
  /** Value for controlled usage */
  value: optionalPropType(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired)),
  /** Handle for item click event */
  onChange: PropTypes.func,
  /** Handle closing of the menu */
  onClose: PropTypes.func,
  /** render custom menu item */
  renderItem: PropTypes.elementType
});
export default OverlayMenuItem;
//# sourceMappingURL=OverlayMenuItem.js.map